import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fget, fpost } from 'src/lib/fetch';
import { DeviceDetailPanel } from 'src/modules/map-dialog/components/DialogWaterLevel.component';
import { MapDevicePanel } from 'src/redux/slices/mapDevicePanels.slice';
import './DevicePanelWindow.css';

const getLatestDeviceRecord = async (deviceId: string) => {
  const response = await fpost<any>('api/device/record/query', {
    body: {
      query: {
        ExpressionAttributeValues: {
          ':id': { S: deviceId },
        },
        KeyConditionExpression: 'DEVICE_ID = :id',
        TableName: 'DEVICE_RECORD',
        ScanIndexForward: false,
        Limit: 1,
      },
    },
  });
  return response?.[1]?.Items?.[0];
};

export function DevicePanelWindowPage() {
  const { deviceId = '' } = useParams();
  const [device, setDevice] = useState<MapDevicePanel | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    const loadDevice = async () => {
      try {
        const response = await fget('api/devices?status=ACTIVE');
        const item = (response?.[1]?.Items || []).find((candidate: any) => candidate.DEVICE_ID?.S === deviceId);
        if (!item) throw new Error('デバイスが見つかりません。');

        const record = await getLatestDeviceRecord(deviceId);
        if (cancelled) return;
        setDevice({
          deviceId,
          pos: item.DEVICE_NAME?.S || deviceId,
          waterLevel: record?.WATER_LEVEL?.S || '0',
          flowRate: record?.FLOW_RATE?.S || '0',
          velocity: record?.VELOCITY?.S || '0',
          publish: record?.Publish?.S || record?.PUBLISH?.S || record?.PUBLISH_FORMATED?.S || '',
          areaName: item.AREA_NAME?.S || '',
          riverName: item.RIVER_NAME?.S || '',
        });
      } catch (loadError) {
        if (!cancelled) {
          setError(loadError instanceof Error ? loadError.message : 'デバイス情報の取得に失敗しました。');
        }
      }
    };

    void loadDevice();
    return () => {
      cancelled = true;
    };
  }, [deviceId]);

  return (
    <main className="device-panel-windowPage">
      {error ? <div className="device-panel-windowMessage is-error">{error}</div> : null}
      {!error && !device ? <div className="device-panel-windowMessage">デバイス情報を読み込んでいます...</div> : null}
      {device ? <DeviceDetailPanel dataDialog={device} layoutMode="embedded" /> : null}
    </main>
  );
}
